import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  'en': {
    'subtitle': 'Using computer vision to identify and count mosquito eggs.',
    'description': "This is a proof-of-concept web app to develop a way to algorithmically detect mosquito eggs and egg cluster on ovitrap paper using computer vision. Try out the app using the 'demo' image -- or check out the guide for more information.",
    'Select Image': 'Select Image',
    'Demo Image': 'Demo Image',
    'Select the ovitrap image type': 'Select the ovitrap image type',
    'Paper Strip': 'Paper Strip',
    'Paper-Description': 'Ovitrap paper is rectangular in shape (approx. 32cm X 8cm), on white pellon fabric with gray-black mosquito eggs.',
    'Magnified': 'Magnified',
    'Magnified-Description': 'Ovitrap paper is less narrow than a paper strip, on white pellon fabric with gray-black mosquito eggs that appear larger in the image.',
    'Microscope': 'Microscope',
    'Microscope-Description': 'Image is square, and mosquito eggs are clearly visible as large objects.',
    'Rotate': 'Rotate',
    'Remove': 'Remove',
    'Analyze': 'Analyze',
    'Analyzing Image...': 'Analyzing Image...',
    'Filters': 'Filters',
    'Image Threshold Adjustment': 'Image Threshold Adjustment',
    'Image Threshold Adjustment Details': 'Use this slider to separate background image "noise" and scan for just the eggs.',
    'Minimum Egg Size': 'Minimum Egg Size',
    'Minimum Egg Size Details': "The minimum (smallest single egg) radius for the algorithm — anything smaller will be 'grayed out' and not calculated.",
    'Maximum Egg Size': 'Maximum Egg Size',
    'Maximum Egg Size Details': 'The maximum radius for the eggs — anything larger will be considered a cluster.',
    'Maximum Cluster Size': 'Maximum Cluster Size',
    'Maximum Cluster Size Details': 'The maximum radius for the cluster of eggs — anything larger will be discarded.',
    'Egg Size Scale': 'Egg Size Scale',
    'Egg Size Scale Details': 'Use these sliders to set the minimum (smallest single egg) radius for the algorithm.',
    'Too Large / Too Small': 'Too Large / Too Small',
    'Reset': 'Reset',
    'of': 'of',
    'Source Image': 'Source Image',
    'Threshold': 'Threshold',
    'Detected Objects': 'Detected Objects',
    'Sorted Markers': 'Sorted Markers',
    'Outlined Overlay': 'Outlined Overlay',
    'Analysis': 'Analysis',
    'Details': 'Details',
    'Single Eggs': 'Single Eggs',
    'Calculated from Clusters': 'Calculated from Clusters',
    'Total Egg Estimation': 'Total Egg Estimation',
    'Total Single Egg Area': 'Total Single Egg Area',
    'Single Egg Average Size': 'Single Egg Average Size',
    'Egg Clusters': 'Egg Clusters',
    'Total Egg Clusters Area': 'Total Egg Clusters Area',
    'Average Cluster Area': 'Average Cluster Area',
    'Average Eggs per Cluster': 'Average Eggs per Cluster',
    'Image Size': 'Image Size',
    'Close': 'Close',
    'Compare': 'Compare',
    'Show Filters': 'Show Filters'
  },
  'pt': {
    'subtitle': 'Visão computacional para identificar e contar ovos do mosquito Aedes Aegypti.',
    'description': "Este é um aplicativo PWA para detectar algoritmicamente ovos do mosquito Aedes Aegypti em palhetas de ovitrampa usando visão computacional.",
    'Select Image': 'Selecionar Imagem',
    'Demo Image': 'Imagem Demo',
    'Select the ovitrap image type': 'Selecione o tipo de Foto da Palheta.',
    'Paper Strip': 'Palheta',
    'Paper-Description': 'Foto da Palheta Inteira.',
    'Magnified': 'Palheta Macro',
    'Magnified-Description': 'Foto da palheta com zoom.',
    'Microscope': 'Palheta Micro',
    'Microscope-Description': 'Foto da palheta com zoom máximo.',
    'Rotate': 'Girar',
    'Remove': 'Retirar',
    'Analyze': 'Analizar',
    'Analyzing Image...': 'Analisando Imagen...',
    'Filters': 'Filtros',
    'Image Threshold Adjustment': 'Ajustando o limite da imagem',
    'Image Threshold Adjustment Details': 'Use este controle deslizante para separar o "ruído" da imagem de fundo e digitalize apenas os ovos.',
    'Minimum Egg Size': 'Tamanho mínimo do ovo',
    'Minimum Egg Size Details': "O raio mínimo (o menor ovo único) para o algoritmo; Qualquer coisa menor será \"atenuada\" e não calculada.",
    'Maximum Egg Size': 'Tamanho máximo do ovo',
    'Maximum Egg Size Details': 'O raio máximo para ovos: Qualquer coisa maior será considerada um aglomerado.',
    'Maximum Cluster Size': 'Tamanho máximo do cluster',
    'Maximum Cluster Size Details': 'O raio máximo para o cacho de ovos: tudo o que for maior será descartado.',
    'Egg Size Scale': 'Escala de tamanho do ovo',
    'Egg Size Scale Details': 'Use esses controles deslizantes para definir o raio mínimo (o menor ovo) para o algoritmo.',
    'Too Large / Too Small': 'Muito grande / muito pequeno',
    'Reset': 'Reiniciar',
    'of': 'de',
    'Source Image': 'Fonte da imagem',
    'Threshold': 'Limite',
    'Detected Objects': 'Objetos Detectados',
    'Sorted Markers': 'Marcadores Ordenados',
    'Outlined Overlay': 'Sobreposição delineada',
    'Analysis': 'Análise',
    'Details': 'Detalhes',
    'Single Eggs': 'Ovos individuais',
    'Calculated from Clusters': 'Calculado a partir de clusters',
    'Total Egg Estimation': 'Estimativa Total de Ovos',
    'Total Single Egg Area': 'Área total de um único ovo',
    'Single Egg Average Size': 'Tamanho médio do ovo único',
    'Egg Clusters': 'Cachos de Ovos',
    'Total Egg Clusters Area': 'Área Total dos Cachos de Ovos',
    'Average Cluster Area': 'Área média do cluster',
    'Average Eggs per Cluster': 'Média de Ovos por Cacho',
    'Image Size': 'Tamanho da imagem',
    'Close': 'Cerca',
    'Compare': 'Comparar',
    'Show Filters': 'Mostrar Filtros'
  }
}

const i18n = new VueI18n({
  locale: 'pt', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages
})

export default i18n
